import { BiCheck } from "react-icons/bi";
import { Button, Card, Col, Row, theme } from "antd";
import React from "react";
import { AiOutlineCalendar } from "react-icons/ai";
import { useNavigate } from "react-router-dom";

export const PrestationAnswerYes = props => {
  const {
    token: { colorPrimary },
  } = theme.useToken();

  const navigate = useNavigate();

  return (
    <div className={"center-full"}>
      <Card className={"confirmYes"}>
        <div className={"checkBig"}>
          <BiCheck color={colorPrimary} size={60} />
        </div>
        <h2>Merci d'avoir accepté la prestation</h2>

        <p>
          Votre confirmation a été transmise à l'institution concernée, vous
          retrouverez de détail de la préstation sur votre compte AVIC.
        </p>
        <Row style={{ width: "100%" }}>
          <Col md={12} xs={24}>
            <Button
              size={"large"}
              className={"confirmButton"}
              type={"primary"}
              icon={<AiOutlineCalendar size={20} />}
            >
              Ajouter à mon agenda
            </Button>
          </Col>
          <Col md={12} xs={24}>
            <Button
              size={"large"}
              className={"confirmButton"}
              onClick={() => {
                navigate("/", { replace: true });
              }}
            >
              Retour à l'accueil
            </Button>
          </Col>
        </Row>
      </Card>
    </div>
  );
};
